import {Component} from "react";

export interface ExternalHTMLContentProps {
    contentHtml?: string;
}

class ExternalHTMLContent extends Component<ExternalHTMLContentProps> {

    render() { return (
        <div dangerouslySetInnerHTML={{ __html: this.props.contentHtml ?? '' }} ></div>
    )}

}

export default ExternalHTMLContent;
